import {
	sendBrazeBidsActiveEvent,
	sendBrazeBidsDidntWinEvent,
	sendBrazeBidsUnderOfferEvent,
	sendBrazePurchasesCancelledEvent,
	sendBrazePurchasesCompletedEvent,
} from 'Services/braze/brazeEvents';
import { AccountSlugs } from 'Types/account';

import type { AmountFallback } from './AccountPage.types';

export const DEFAULT_VEHICLES_PAGE_SIZE = 25;

export const DEFAULT_START_PAGE = 1;

export const DEFAULT_PAGE_OFFSET = 1;

export const ACCOUNT_CATEGORIES = Object.freeze({
	BIDS_AND_OFFERS: 'bids',
	PURCHASES: 'purchases',
});

export const TEXT_FALLBACK = '-' as AmountFallback;

export const SLUG_BRAZE_DICT: Record<AccountSlugs, () => Promise<void>> = {
	[AccountSlugs.COMPLETE]: sendBrazePurchasesCompletedEvent,
	[AccountSlugs.CANCELLED]: sendBrazePurchasesCancelledEvent,
	[AccountSlugs.ACTIVE]: sendBrazeBidsActiveEvent,
	[AccountSlugs.DIDNT_WIN]: sendBrazeBidsDidntWinEvent,
	[AccountSlugs.UNDER_OFFER]: sendBrazeBidsUnderOfferEvent,
};
